

import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";
import { Container, Header, Label, Loader } from 'semantic-ui-react';
import UserCache from "../../../../helpers/cache/userCache";
import UserListTabs from './UserListTabs';

class UsersTabs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {

        }

    }

    render() {
        const { selectedAccount, accountInvitedUser, userCache } = this.props;
        const { activeIndex } = this.state;
         const accountUserData = {
            CustomerAdmin: [],
            User: []
        }
        accountUserData.CustomerAdmin = this.props.selectedAccount.users.filter(user => user.role === "customerAdmin").map(user => user.id);
        accountUserData.User = this.props.selectedAccount.users.filter(user => user.role === "user").map(user => user.id);
        let totalUserLength = accountUserData.CustomerAdmin.length + accountUserData.User.length

        return (
            <Container fluid className="pad_20 listingUsers three-block">
                <div className="listHeader">
                    <Header as='h4' floated='left'>
                        Manage Users
                        {totalUserLength ?
                            <Label size="small" >{totalUserLength === 0 ? 0 :
                                totalUserLength > 0 ? totalUserLength :
                                    <Loader active inline size='mini' />
                            }</Label> : null}
                    </Header>
                    <div className="float-right"></div>
                </div>
                <div className="listTab">
                    <UserListTabs {...this.props} />
                </div>
            </Container>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

const connectedUsers = withRouter(connect(mapStateToProps)(UsersTabs));
export { connectedUsers as UsersTabs };
